// src/components/event/EventMenuOverview.jsx  (or match your casing consistently)
import React, { useEffect, useMemo, useState } from "react";
import api from "@/lib/axios";

export default function EventMenuOverview({ eventId }) {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get(`/inventory/event-menu-plan/${eventId}`);
        if (alive) setPlan(data);
      } catch (e) {
        if (alive) setPlan(null);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [eventId]);

  const items = plan?.planned_items || [];
  const totalServings = useMemo(
    () => items.reduce((a, it) => a + Number(it.servings || 0), 0),
    [items]
  );

  if (loading) return <div className="text-slate-400">Loading menu plan…</div>;

  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-2xl p-5">
      <div className="flex items-center justify-between mb-3">
        <div className="text-lg font-semibold text-white">🍽️ Menu Plan</div>
        <div className="text-xs text-slate-400">
          {items.length} items · {totalServings} portions
        </div>
      </div>

      {items.length === 0 ? (
        <div className="text-slate-400 text-sm">
          No menu items saved yet. Add items in Event Form / Menu Selection and save.
        </div>
      ) : (
        <div className="space-y-2">
          {items.map((it) => (
            <div
              key={it.menu_item_id}
              className="flex items-center justify-between border-b border-slate-800/60 pb-2"
            >
              <div className="min-w-0">
                <div className="font-medium text-slate-100 truncate">
                  {it.menu_item_name || it.name || `Item #${it.menu_item_id}`}
                </div>
                <div className="text-xs text-slate-400">
                  cost/serving: {Number(it.effective_cost_per_serving || 0).toFixed(2)}
                  {it.food_cost_pct != null ? ` · FC% ${Number(it.food_cost_pct).toFixed(1)}%` : ""}
                </div>
              </div>
              <div className="text-slate-200 shrink-0">
                portions: <span className="font-semibold">{Number(it.servings || 0)}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}